module.exports = __webpack_public_path__ + "assets/retina_EquilateralOnCCDetailed.d8ed82a7b1e1e8d56ff3b320ee3bf181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_EquilateralOnCCDetailed.png
// module id = 666
// module chunks = 0